<template>
  <path
    d="M7.99994 2.25C8.19883 2.25002 8.38958 2.32909 8.53022 2.46973L12.5302 6.46973C12.8231 6.76261 12.8231 7.23739 12.5302 7.53027C12.2373 7.82316 11.7626 7.82314 11.4697 7.53027L8.74994 4.81055L8.74994 13C8.74994 13.4142 8.41413 13.75 7.99994 13.75C7.58573 13.75 7.24994 13.4142 7.24994 13L7.24994 4.81055L4.53022 7.53027C4.23733 7.82316 3.76257 7.82314 3.46967 7.53027C3.17678 7.23738 3.17678 6.76262 3.46967 6.46973L7.46967 2.46973L7.58393 2.37598C7.70622 2.29446 7.8508 2.25 7.99994 2.25Z"
    fill="currentColor"
  />
</template>
